import React from "react";
import { Link } from "react-router-dom";
import { Project } from "../data/projects";
import ProjectArtwork from "./ProjectArtwork";

export default function ProjectCard({
  project,
  number,
}: {
  project: Project;
  number: number;
}) {
  return (
    <article
      className={`project-card project-${project.id}`}
      id={project.legacyId}
    >
      <Link
        className="project-art"
        to={`/projects/${project.id}`}
        aria-label={`Explore ${project.name}`}
      >
        <ProjectArtwork project={project} compact />
        <span className="art-number" aria-hidden="true">
          0{number}
        </span>
      </Link>
      <div className="project-body">
        <div className="project-heading">
          <img
            className="project-icon"
            src={project.icon}
            width="48"
            height="48"
            alt=""
            loading="lazy"
          />
          <div>
            <p className="eyebrow">{project.category}</p>
            <h3>
              <Link to={`/projects/${project.id}`}>{project.name}</Link>
            </h3>
          </div>
          {project.id === "veld" && <span className="new-tag">New</span>}
        </div>
        <p className="project-tagline">{project.tagline}</p>
        <p className="project-description">{project.description}</p>
        <div className="project-links">
          <Link to={`/projects/${project.id}`}>
            Explore project <span aria-hidden="true">→</span>
          </Link>
          <a href={project.link}>
            Visit website <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </article>
  );
}
